export const chargeConstants = {
    CHARGE_FETCHING: 'CHARGE_FETCHING',
    CHARGE_FETCHED: 'CHARGE_FETCHED',
    GET_CHARGES: 'GET_CHARGES',
    GET_CHARGE_BY_ID: 'GET_CHARGE_BY_ID',
    UPDATE_CHARGE: 'UPDATE_CHARGE',
    UPDATED_CHARGE: 'UPDATED_CHARGE',
    SEARCH_CHARGE: 'SEARCH_CHARGE',
    GET_FULL_CHARGES: 'GET_FULL_CHARGES',
    GET_CHARGE_FOR_CREATE_CHARGE: 'GET_CHARGE_FOR_CREATE_CHARGE',
    GET_GL: 'GET_GL',
    GET_STRIPPING_STUFFING_SELECTION: 'GET_STRIPPING_STUFFING_SELECTION',
    GET_MASTER_CHARGE: 'GET_MASTER_CHARGE',
}